const cities = [
  { name: "Roseville", zips: "55112, 55113" },
  { name: "St. Paul", zips: "55101–55119" },
  { name: "Little Canada", zips: "55117" },
  { name: "Shoreview", zips: "55126" },
  { name: "Arden Hills", zips: "55112" },
  { name: "Maplewood", zips: "55109" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your Roseville home or office in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function RosevilleLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white pt-12 md:pt-14 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Roseville &amp; North Ramsey County
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Roseville, Minnesota is a thriving first-ring suburb located directly north of St. Paul, sitting between the Twin Cities' two major urban centers. The city is anchored by Rosedale Center, one of the Twin Cities' premier shopping destinations, which brings significant retail employment and consumer traffic from across the north metro. Roseville's strategic location at the intersection of Interstate 35W and I-694 makes it one of the most accessible communities in the Twin Cities.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The city's commercial corridors along Snelling Avenue, Lexington Avenue, and County Road B are home to corporate offices, healthcare facilities, and professional services. Many Roseville residents work in healthcare at nearby hospitals, in professional services firms with international clients, and in technology companies with global operations. These professionals frequently travel internationally for work.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Roseville's residential neighborhoods are diverse and well-established, attracting families, young professionals, and retirees who appreciate the city's convenient location. The proximity to both St. Paul and Minneapolis creates a community that benefits from both cities' employment bases and cultural offerings. International travel is a natural part of life for many Roseville residents.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              The city's diverse population, including significant Hmong, Vietnamese, and other Asian American communities, maintains strong international connections. Heritage travel to Southeast Asia, cultural events, and family visits are common. These communities value expedited passport services that allow them to respond quickly to family needs abroad.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Roseville, MN</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving all of Ramsey County remotely</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Remote service — serving Roseville, St. Paul, Little Canada, Shoreview, Arden Hills &amp; Maplewood
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Ship your documents overnight from anywhere in the north metro</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, ship your documents with our <strong className="text-white">prepaid overnight label</strong> from any UPS or FedEx location near Rosedale Center. Most clients never need to visit an office — just start online, ship overnight, and we handle the rest.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline truncate ml-2 max-w-[160px]">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Ramsey County and the north metro — start online, ship overnight, and we handle the rest.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "St. Paul", href: "/st-paul" },
                    { name: "Minneapolis", href: "/minneapolis" },
                    { name: "Maplewood", href: "/maplewood" },
                    { name: "Shoreview", href: "/minnesota" },
                    { name: "Arden Hills", href: "/minnesota" },
                    { name: "Little Canada", href: "/minnesota" },
                  ].map((link) => (
                    <a
                      key={link.href + link.name}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Roseville Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}